 <template>
    <div :id="!wapShow?'app':''">
        <div :style="!wapShow?'width: 1200px;margin: 0 auto':''">
         <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import eventBus from "./assets/js/eventBus";
    export default {
        name: 'app',
        data(){
            return{
                wapShow:false
            }
        },
        mounted() {
            let _that = this;
            _that.sizes()

            window.addEventListener('resize',()=>{
                _that.sizes()
            })
        },
        methods:{
            sizes(){
                let _that = this;
                !function (window) {
                    /* 设计图文档宽度 */
                    var docWidth = 1500;
                    var doc = window.document,
                        docEl = doc.documentElement,
                        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
                    var recalc = (function refreshRem() {
                        /* 窗口当前宽度 */
                        var clientWidth = window.innerWidth;
                        if (clientWidth > 1200) {
                            var oldSize = (clientWidth / docWidth * 100) + 'px';
                            docEl.style.fontSize = 12 + 'px';
                            _that.wapShow=false
                            eventBus.$emit("wapShow",false)
                        } else {
                            docWidth = 750;
                            _that.wapShow=true
                            var oldSize1 = (clientWidth / docWidth * 100) + 'px';
                            docEl.style.fontSize = oldSize1;
                            eventBus.$emit("wapShow",true)
                        }

                        //
                        /* 获取设置后的字体大小情况 - 因微信设置APP字体大小后会影响该设置 */
                        var nowSize = window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize;
                        var oldSizeValue = parseFloat(oldSize, 10);
                        var nowSizeValue = parseFloat(nowSize, 10);
                        /* 当差值大于1时重新按差比计算出正确的px值 */
                        if ((nowSizeValue - oldSizeValue) > 1 || (nowSizeValue - oldSizeValue) < -1) {
                            var diff = (oldSizeValue / nowSizeValue);
                            // docEl.style.fontSize = (clientWidth/docWidth* 100*diff) + 'px';
                        }
                        return refreshRem;
                    })();
                    /* 添加倍屏标识，安卓为1 */
                    docEl.setAttribute('data-dpr', window.navigator.appVersion.match(/iphone/gi) ? window.devicePixelRatio : 1);
                    if (/iP(hone|od|ad)/.test(window.navigator.userAgent)) {
                        /* 添加IOS标识 */
                        doc.documentElement.classList.add('ios');
                        /* IOS8以上给html添加hairline样式，以便特殊处理 */
                        if (parseInt(window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10) >= 8)
                            doc.documentElement.classList.add('hairline');
                    }
                    if (!doc.addEventListener) return;
                    window.addEventListener(resizeEvt, recalc, false);
                    doc.addEventListener('DOMContentLoaded', recalc, false);
                }(window);
            }
        }
    }
</script>

<style>
    .wap-box{
        padding-top: .88rem;
    }
    .el-dropdown-menu{
        border-radius: 10px !important;
    }
    body{
        margin: 0;
    }
    ul{
        padding: 0;
        border-right: 0;
    }
    a{
        text-decoration:none
    }
    p{
        margin: 0;
    }
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        position: fixed;
        width: 100%;
        height: 100%;
        overflow: auto;
        background: url("./assets/image/gebuerstetes_metall.jpg");
    }

    .flex {
        display: flex;
    }
    ul{
        padding: 0;
        margin: 0;
    }
    li{
        list-style: none;
    }
</style>
